<div class="container">
    <div class="row">
        <div class="col-md-12">
            <h1><i class="fa fa-fw fa-shopping-bag" aria-hidden="true"></i> Analyse des ventes</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <h3>entre le
                <input type="date" class="form-control" id="fromDate"
                       required #name="ngModel" name="fromDate"
                       [(ngModel)]="fromDate">
                et le
                <input type="date" class="form-control" id="toDate"
                       required #name="ngModel" name="toDate"
                       [(ngModel)]="toDate">
            </h3>
        </div>
    </div>
    <div class="row">
        <!--Trainings-->
        <training-data-analysis class="col-md-6" style="padding-right: 50px"
                                [fromDate]="fromDate" [toDate]="toDate">
        </training-data-analysis>

        <!--Companies-->
        <company-data-analysis class="col-md-6" style="padding-left: 50px"
                               [fromDate]="fromDate" [toDate]="toDate">
        </company-data-analysis>
    </div>

</div>


// WEBPACK FOOTER //
// ./src/app/_screens/stats/data-analysis/data-analysis.component.html